// extracted by mini-css-extract-plugin
export var tosLink = "_41-0";